import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

// 卓の連結(卓グループ)。親卓 tableId に対する singular resource。
// 一覧は Hall.getHalls({ isOperation: true }) の hall.attributes.tableGroups で返る
export default {
  createTableGroup(tableId, { tableNumbers }) {
    return axiosIns.post(`/waiter/tables/${tableId}/table_group`, snakecaseKeys({ tableNumbers }))
  },
  updateTableGroup(tableId, { tableNumbers }) {
    return axiosIns.patch(`/waiter/tables/${tableId}/table_group`, snakecaseKeys({ tableNumbers }))
  },
  deleteTableGroup(tableId) {
    return axiosIns.delete(`/waiter/tables/${tableId}/table_group`)
  },
  removeTableGroupMember(tableId, tableNumber) {
    return axiosIns.delete(`/waiter/tables/${tableId}/table_group/members/${tableNumber}`)
  },
}
